
import React, { createContext, useContext, useState } from 'react';
import PrivateRoutes from './Routes/PrivateRoutes';
import { Router } from 'react-router';

import { RouterProvider } from 'react-router';
import { PublicRoutes } from './Routes';
import { useSelector } from 'react-redux';
import { Button, Card, ConfigProvider, theme } from "antd";
import Login from "./Components/Login/login";
import ThemeProvider, { ThemeContext } from "./Utils/ThemeProvider";
import AuthProvider from "./Auth/AuthProvider";  

const StyleTag = ({ children }) => {
  const { defaultAlgorithm, darkAlgorithm } = theme;
  const themeMode = useContext(ThemeContext);
  return (
    <ConfigProvider theme={{ algorithm: themeMode.isDarkMode ? darkAlgorithm : defaultAlgorithm }}>
      {children}
    </ConfigProvider>
  );
};
function App() {
  const privateRoute = PrivateRoutes;
  const publicRoute = PublicRoutes;
  const auth = useSelector((state) => state.auth.value); // Removed type annotation
  // const [theme, setTheme] = useState('dark');

  // const toggleTheme = () => {
  //   const newTheme = theme === 'light' ? 'dark' : 'light';
  //   setTheme(newTheme);
  // }

  const themeMode = useContext(ThemeContext);

  // const routes = auth ? <PrivateRoutes /> : <PublicRoutes />;


  return (
    // <RouterProvider router={privateRoute} />
    <AuthProvider>
      <ThemeProvider>
        <StyleTag >
          <RouterProvider router={privateRoute} />
        </StyleTag>
      </ThemeProvider>
    </AuthProvider>

    //
  );

}

export default App;
